import React from 'react'

import { PublicAuthoritiesHierarchyContainer } from '@/components/containers/public-authorities-hierarchy/PublicAuthoritiesHierarchyContainer'

const PublicAuthoritiesHierarchyPage: React.FC = () => <PublicAuthoritiesHierarchyContainer />

export default PublicAuthoritiesHierarchyPage
